import { formatCompletedTime, formatRelativeTime } from "../../intelligence/intelligenceLabels";
import SourceHealthBadge from "../SourceHealthBadge";
import AdminTableContainer from "../layout/AdminTableContainer";

function providerStatusTone(status) {
  const normalized = String(status || "").toLowerCase();
  if (normalized === "ok") {
    return "ok";
  }
  if (normalized === "degraded") {
    return "degraded";
  }
  if (normalized === "failed") {
    return "failed";
  }
  return normalized || "unknown";
}

const WeatherHealthHistoryModal = ({
  source,
  records,
  isOpen,
  isLoading,
  errorMessage,
  onClose,
}) => {
  if (!isOpen || !source) {
    return null;
  }

  return (
    <div className="admin-re-modal-backdrop" role="presentation" onClick={onClose}>
      <div
        className="admin-re-modal panel-card"
        role="dialog"
        aria-labelledby="weather-health-modal-title"
        onClick={(event) => event.stopPropagation()}
      >
        <header className="admin-re-modal-header">
          <div>
            <p className="eyebrow">Provider health</p>
            <h2 id="weather-health-modal-title">{source.sourceName}</h2>
            <p className="muted admin-re-source-code">{source.sourceCode}</p>
          </div>
          <button type="button" className="midpoint-share-button" onClick={onClose}>
            Close
          </button>
        </header>

        <div className="admin-re-modal-body">
          {isLoading ? <p className="muted">Loading health history…</p> : null}
          {errorMessage ? <p className="admin-re-error">{errorMessage}</p> : null}

          {!isLoading && !errorMessage && !records?.length ? (
            <p className="muted">No provider health checks recorded yet.</p>
          ) : null}

          {!isLoading && records?.length ? (
            <AdminTableContainer>
              <table className="admin-data-health-table">
                <thead>
                  <tr>
                    <th>Checked</th>
                    <th>Status</th>
                    <th>Latency</th>
                    <th>Records</th>
                    <th>Latest data</th>
                    <th>Error</th>
                  </tr>
                </thead>
                <tbody>
                  {records.map((record) => (
                    <tr key={record.id}>
                      <td>{formatRelativeTime(record.checkedAt)}</td>
                      <td>
                        <SourceHealthBadge status={providerStatusTone(record.status)} />
                      </td>
                      <td>{record.latencyMs != null ? `${record.latencyMs} ms` : "—"}</td>
                      <td>{record.recordsReceived ?? "—"}</td>
                      <td>{formatCompletedTime(record.latestDataTimestamp)}</td>
                      <td className="admin-re-error-cell">{record.errorMessage || "—"}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </AdminTableContainer>
          ) : null}
        </div>
      </div>
    </div>
  );
};

export default WeatherHealthHistoryModal;
